import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import { tableCellRender, stringFilterOperators } from "../util/tableUtils";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";

import { ramo } from "../../data/ramoTransitorio";

export const RamoTransitorioList = (props) => {
  const { t } = useTranslation();

  const perilColumns = [
    {
      field: "perilGroup",
      headerName: t("perilGroup.perilCode"),
    },
    {
      field: "perilGroup2",
      headerName: t("perilGroup.description"),
      valueGetter: ({ id }) => ramo[props?.perils?.find((item) => item._id === id)?.perilGroup],
    },
    {
      field: "postrenewalValueFinal",
      headerName: t("perilGroup.insuredValue"),
      filterable: false,
    },
    {
      field: "premiumAccesories",
      headerName: t("perilGroup.premium"),
      filterable: false,
    },
  ];

  const columns = perilColumns.map((tableColumn) => ({
    valueFormatter: (params) => tableCellRender(params.value),
    filterOperators: stringFilterOperators,
    ...tableColumn,
    width: 200,
  }));

  return (
    <Box pt={1}>
      <Paper>
        <Box p={2} pt={2}>
          <Typography
            variant={"h2"}
            style={{
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("perilGroup.title")}
          </Typography>
        </Box>
        <div style={{ maxHeight: "40vw", maxWidth: "100%", overflow: "auto" }}>
          <DataGridCystellarTable
            columns={columns}
            rows={props?.perils}
            rowCount={props?.perils.length}
            getRowId={(rowData) => rowData._id}
            pagination={false}
            loading={props.isLoading}
            customToolbarComp={true}
            customToolbarCompMsg={props.lastUpdate}
            customNoRowsMsg={t("policy.emptyPerilsList")}
          />
        </div>
      </Paper>
    </Box>
  );
};
